export const TABLE_RESTRICTION_CONFIG = {
  restrictColumns: true,
  restrictColumnsMinCount: 2,
  restrictColumnsMaxCount: 7,
};
